import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/components/HomePage.vue';
import TheShirts from '@/components/TheShirts.vue';
import TheHoodies from '@/components/TheHoodies.vue';
import ThePants from '@/components/ThePants.vue';
import TheSweatshirts from '@/components/TheSweatshirts.vue';
import TheCoats from '@/components/TheCoats.vue';
import TheCart from '@/components/TheCart.vue';
import TheWishlist from '@/components/TheWishlist.vue';
import NotFound from '@/components/NotFound.vue';
import RegistrationForm from '@/components/RegistrationForm.vue';
import UserProfile from '@/components/UserProfile.vue';
import AllItems from '@/components/AllItems.vue';
import ProductInfo from '@/components/ProductInfo.vue';
import MakingOrder from '@/components/MakingOrder.vue';
import UserOrders from '@/components/UserOrders.vue';
import RecentlyViewed from '@/components/RecentlyViewed.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomePage
    },
    {
        path: '/T-shirts',
        name: 'Tshirts',
        component: TheShirts
    },
    {
        path: '/Hoodies',
        name: 'Hoodies',
        component: TheHoodies
    },
    {
        path: '/Pants',
        name: 'Pants',
        component: ThePants
    },
    {
        path: '/Sweatshirts',
        name: 'Sweatshirts',
        component: TheSweatshirts
    },
    {
        path: '/Coats',
        name: 'Coats',
        component: TheCoats
    },
    {
        path: '/All-items',
        name: 'AllItems',
        component: AllItems
    },
    {
        path: '/Product-info/:id',
        name: 'ProductInfo',
        component: ProductInfo,
        props: true
    },
    {
        path: '/Cart/:userId',
        name: 'Cart',
        component: TheCart,
    },
    {
        path: '/Wishlist/:userId',
        name: 'Wishlist',
        component: TheWishlist,
    },
    {
        path: '/Registration',
        name: 'Registration',
        component: RegistrationForm,
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            if (userData) {
                // Если пользователь уже зарегистрирован, перенаправляем на профиль
                next(`/Profile/${JSON.parse(userData).id}`);
            } else {
                next(); // Иначе продолжаем на регистрацию
            }
        }
    },
    {
        path: '/Ordering',
        name: 'Ordering',
        component: MakingOrder,
    },
    {
        path: '/Orders/:id',
        name: 'UserOrders',
        component: UserOrders,
    },
    {
        path: '/Profile/:id',
        name: 'Profile',
        component: UserProfile,
        meta: { requiresAuth: true }
    },
    {
        path: '/Recently-viewed',
        name: 'RecentlyViewed',
        component: RecentlyViewed
    },
    {
        path: '/:notFound(.*)',
        name: 'NotFound',
        component: NotFound,
    }

];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0, behavior: "smooth" };
    },
});

export default router